import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import PropTypes from 'prop-types'

import * as Sc from './CourseForm.style'
import {
  BottomActionBar,
  BottomActionBarWrapper,
} from 'components/BottomActionBar'
import Button from 'components/Button'
import Radio from 'components/Radio'
import { RowWrapper, Row } from 'components/Row'
import Title from 'components/Title'
import { fetchCoursesAvailableAction } from 'store/actions/student.actions'
import { formatCurseName } from 'utils'

const CourseForm = ({ onCancel, onSubmit }) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { newStudent } = useSelector(({ students }) => students)
  const { availableCourses, name } = newStudent || {}
  const [levels, setLevels] = useState([])
  const [selected, setSelected] = useState(null)
  const setCoursesList = async () => {
    await dispatch(fetchCoursesAvailableAction())
  }

  useEffect(() => {
    setCoursesList()
  }, [])

  useEffect(() => {
    if (availableCourses?.length) {
      const courses = availableCourses.map((course) => course.level.name)
      setLevels([...new Set(courses)])
    }
  }, [newStudent])

  const handleChange = (course) => {
    setSelected(course)
  }

  const handleSubmit = () => {
    onSubmit(selected)
  }

  return (
    <BottomActionBarWrapper>
      {availableCourses?.length && (
        <Sc.Container>
          <Title
            subtitle={t(
              'Si todavía no sabes el curso al que vas, pídeselo a tu profesor/a'
            )}
            title={t('¿A qué curso va {{name}}?', { name })}
          />
          <RowWrapper>
            {levels.map((unique) => (
              <Row borderBottom key={unique}>
                {availableCourses.map(
                  (course) =>
                    course.level.name === unique && (
                      <Radio
                        checked={!!selected && selected.id === course.id}
                        classes={{ medium: true }}
                        id={course.id}
                        key={course.id}
                        name='courses'
                        onChange={() => handleChange(course)}
                        onClick={() => handleChange(course)}
                        value={course.id}
                      >
                        {formatCurseName({ course })}
                      </Radio>
                    )
                )}
              </Row>
            ))}
          </RowWrapper>
          <BottomActionBar>
            <Button classes={{ second: true }} onPress={onCancel}>
              {t('No unirme a ninguna clase')}
            </Button>
            <Button disabled={!selected} onPress={handleSubmit}>
              {t('Siguiente')}
            </Button>
          </BottomActionBar>
        </Sc.Container>
      )}
    </BottomActionBarWrapper>
  )
}

CourseForm.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
}
export default CourseForm
